import { Input } from './ui/input';
import { DollarSign } from 'lucide-react';

export default function DollarInput({ value, onChange, placeholder = '0.00', ...props }) {
  return (
    <div className="relative">
      <div className="absolute left-3 top-1/2 -translate-y-1/2 flex items-center pointer-events-none">
        <DollarSign className="h-4 w-4 text-muted-foreground" />
      </div>
      <Input
        type="number"
        step="0.01"
        min="0.01"
        className="pl-9 tabular-nums"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        {...props}
      />
    </div>
  );
}
